import React, { useState } from "react";
import styles from "./HelpSection.module.scss";
import cx from "classnames";
import CallbackModal from "../Modals/CallbackModal/CallbackModal";
import HelpSectionItem from "./HelpSectionItem/HelpSectionItem";
import { IContactDetails } from "../../interfaces/IContactDetails";

interface IHelpSection {
    groupId?: string;
    contactDetails?: IContactDetails;
    isDisabled?: boolean;
    caseId?: number;
    className?: string;
    title?: string;
    subtext?: string;
}

const HelpSection: React.FC<IHelpSection> = (props) => {
    const { groupId, contactDetails, isDisabled, caseId, className } = props;
    const titleDesktop = props.title || "Need help to choose?";
    const titleMobile = props.title || "Need help to choose or want to see other options?";
    const subtext =
        props.subtext ||
        "Talk to us today! A friendly LifeDirect Insurance Specialist can answer questions and help you choose an insurer.";

    const [isOpenCallback, setIsOpenCallback] = useState(false);

    return (
        <div
            className={cx(
                styles["help-section"],
                "padding-vertical-4xl",
                "padding-horizontal-2xl",
                {
                    [styles["help-section__disabled"]]: isDisabled,
                    [className]: !!className
                }
            )}>
            <CallbackModal
                groupId={groupId}
                contactDetails={contactDetails}
                isOpen={isOpenCallback}
                onClose={() => setIsOpenCallback(false)}
            />
            <div className="text-align--center">
                <h3
                    className={cx(
                        "gap-m",
                        "text-prompt",
                        "hide-mobile"
                    )}>
                    {titleDesktop}
                </h3>

                <h3
                    className={cx(
                        "gap-m",
                        "text-prompt",
                        "hide-non-mobile"
                    )}>
                    {titleMobile}
                </h3>

                <div
                    className={cx(
                        styles["hero-paragraph"],
                        "gap-3xl",
                        "text-font-size-ml"
                    )}>
                    <p className={cx("gap-none")}>{subtext}</p>
                    {caseId > 0 && (
                        <p className={cx("gap-pre-m")}>
                            Quote Reference: {`${caseId}-0`}
                        </p>
                    )}
                </div>
            </div>
            <div
                className={cx(
                    "flex-gap-m",
                    styles["help-icon-row"],
                    "text-font-size-m")}>

                <HelpSectionItem
                    iconId="HelpPhone"
                    title="0800 800 400"
                    link="Call free within New Zealand"
                    href="tel:0800800400"></HelpSectionItem>
                
                <HelpSectionItem
                    iconId="Callback"
                    title="We can call you"
                    link="Request a callback"
                    onClick={() => setIsOpenCallback(true)}></HelpSectionItem>
            </div>
        </div>
    );
};

export default HelpSection;
